import React from 'react';
import PropTypes from 'prop-types';
// import Collapsible from 'react-collapsible';
import MonthTransactionBlock from '../monthtransactionblock';

const YearTransactionBlock = props =>{
  console.log('custid====>', props);
  return (
  <div>
    <div className="statyear">{props.year}</div>
    {
      Object.keys(props.data).sort((mon1, mon2) => mon2 - mon1).map(item => (
        <MonthTransactionBlock key={`'item-${Math.random(2000)}'`} data={props.data[item]} user={props.user} customerID={props.customerID}/>
      ))
    }
  </div>
)};

YearTransactionBlock.propTypes = {
  year: PropTypes.string.isRequired,
  data: PropTypes.shape([]).isRequired,
  user: PropTypes.shape([]).isRequired,
};

export default YearTransactionBlock;
